import { MouseEvent } from "react";

export type ScheduleEvent = {
    id: string;
    title: string;
    occurrenceAt: string;
    disabled?: boolean;
};

export default function ScheduleEventRenderer({
    event,
    onOpenLog,
}: {
    event: ScheduleEvent;
    onOpenLog: (event: ScheduleEvent) => void;
}) {
    const openLog = (click: MouseEvent<HTMLButtonElement>) => {
        click.stopPropagation();
        onOpenLog(event);
    };
    return <span className={`flex items-center justify-between gap-1 ${event.disabled ? "line-through opacity-50" : ""}`}>
        <span className="truncate">{event.title}</span>
        <button type="button" aria-label="View execution history" className="shrink-0 text-primary2" onClick={openLog}>◷</button>
    </span>;
}
